export default __webpack_public_path__ + "static/media/Xcelerator.1866a5aa.png";